import { downloadAuthenticatedFileWithToast, viewAuthenticatedFileWithToast } from "@/components/authenticated-file-link";
import {
  authenticatedAnchorMode,
  isSameOriginApiPath,
  shouldInterceptApiAnchorClick,
} from "@/lib/authenticated-file";

let installed = false;

function isTopLevelNavigation(url: string): boolean {
  const path = url.split("?")[0].split("#")[0];
  // OAuth starts must stay real navigations so the browser can follow the
  // redirect to the provider. Everything else under /api/ is a file or JSON
  // response that 401s in a new tab.
  return /\/(?:gmail\/connect|oauth|callback)(?:\/|$)/.test(path);
}

function onActivate(event: MouseEvent): void {
  if (event.defaultPrevented) return;
  if (!shouldInterceptApiAnchorClick(event.type, event.button)) return;
  const target = event.target;
  if (!(target instanceof Element)) return;
  const anchor = target.closest("a");
  if (!(anchor instanceof HTMLAnchorElement)) return;
  const href = anchor.getAttribute("href");
  if (!href || !isSameOriginApiPath(href) || isTopLevelNavigation(href)) return;
  event.preventDefault();
  event.stopPropagation();
  const fallback = anchor.getAttribute("download") || undefined;
  const mode = authenticatedAnchorMode(href, {
    hasDownloadAttr: anchor.hasAttribute("download"),
    target: anchor.getAttribute("target"),
  });
  if (mode === "view") viewAuthenticatedFileWithToast(href, fallback || undefined);
  else downloadAuthenticatedFileWithToast(href, fallback || undefined);
}

/**
 * Catch leftover same-origin `/api/…` anchors (including modified clicks
 * and middle-clicks). A top-level navigation does not refresh the session
 * the way `apiRequest` does, so those tabs come back 401.
 */
export function installAuthenticatedFileClickInterceptor(): void {
  if (installed || typeof document === "undefined") return;
  installed = true;
  document.addEventListener("click", onActivate, true);
  document.addEventListener("auxclick", onActivate, true);
}
